<template>
  <button
    type="button"
    class="fg-btn fg-btn--icon"
    :disabled="disabled"
    :aria-label="t('common.back')"
    @click="$emit('click')"
  >
    <Icon name="arrow-left" />
  </button>
</template>

<script setup lang="ts">
import { useI18n } from '../../i18n'
import Icon from '../Icon.vue'

defineProps<{ disabled?: boolean }>()
defineEmits<{ click: [] }>()

const { t } = useI18n()
</script>
